import { render, staticRenderFns } from "./UserSelectionView.vue?vue&type=template&id=6c008564"
import script from "./UserSelectionView.vue?vue&type=script&lang=js"
export * from "./UserSelectionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports